import { agentsParentColumns } from "../../agent-production/agent-movement/tableSettings";
import { getAgentMovementTableView } from "../../common/components/table/tableViews/agentMovement";
import { getColumnsFromTableView } from "../../common/helpers/table";

export const propertyNames = Object.freeze({
    defaultSort: 'defaultSort',
    columns: 'columns'
});

export const initialSort = Object.freeze({
    colId: agentsParentColumns.agentsLost.id,
    sortDir: 'desc',
});

export const defaultColumns = getColumnsFromTableView(getAgentMovementTableView({defaultSort: initialSort}));

export const initialTableSettings = Object.freeze({
    [propertyNames.defaultSort]: initialSort,
    [propertyNames.columns]: defaultColumns,
});
